import Card from "@common/components/Card/Card";
import styled from "styled-components";

export const MetricsCard = styled(Card)`
  position: relative;
  background: linear-gradient(rgb(32, 32, 32), rgb(32, 32, 32)) padding-box padding-box,
    linear-gradient(161.27deg, rgb(58, 58, 60) 0%, rgb(32, 32, 32) 50.64%) border-box border-box;
  border: 1px solid transparent;
  border-radius: 2rem;
  padding: 3.2rem 0;
  overflow: hidden;
  flex: 1;
  width: 70rem;
`;
